<template>
    <div>
        <h2>{{ t('choose_right_option') }}</h2>
        <p class="introduction">
            {{ t('one_month_only') }}
        </p>
        <Quiz />
    </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import Quiz from '@/best-fare/components/Quiz.vue';

const { t } = useI18n({
    messages: {
        fr: {
            choose_right_option: "Bien choisir son mode de paiement c'est faire des économies",
            one_month_only:
                "Cet outil permet de calculer le meilleur tarif pour vous, pour une période d'un mois uniquement.",
        },
        en: {
            choose_right_option: 'Save by choosing the right payment option',
            one_month_only: 'This tool lets you calculate your best fare for a one-month period only.',
        },
    },
});
</script>
